module.exports = __webpack_public_path__ + "static/media/logo-nucleus-white.12dc92ed.png";